import React from 'react';
import { CssBaseline, StylesProvider } from '@material-ui/core';
import StyleContext from 'isomorphic-style-loader/StyleContext';
import { SnackbarProvider } from 'notistack';
import { RouteContext, PortalConfigContext, SessionData } from '../../context';

interface UnauthAppProps {
  context: {
    insertCss: (...styles: any[]) => () => void;
    pathname: string;
    query: Record<string, any>;
    isMobile: boolean;
    portalConfig: any;
    sessionData: SessionData;
  };
  children: React.ReactNode;
}

const UnauthApp: React.FC<UnauthAppProps> = ({ context, children }) => {
  // NOTE: If you need to add or modify header, footer etc. of the app,
  // please do that inside the Layout component.
  const {
    insertCss,
    pathname,
    query,
    isMobile,
    portalConfig,
    sessionData,
  } = context;

  const routeContext = React.useMemo(
    () => ({ pathname, query, isMobile, sessionData }),
    [pathname, query, isMobile, sessionData],
  );

  const styleContextValue = React.useMemo(() => ({ insertCss }), [insertCss]);

  return (
    <PortalConfigContext.Provider value={portalConfig}>
      <StyleContext.Provider value={styleContextValue}>
        <StylesProvider>
          <RouteContext.Provider value={routeContext}>
            <CssBaseline />
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              maxSnack={2}
            >
              {React.Children.only(children)}
            </SnackbarProvider>
          </RouteContext.Provider>
        </StylesProvider>
      </StyleContext.Provider>
    </PortalConfigContext.Provider>
  );
};

export default UnauthApp;
